import React from "react";
import { useNavigate } from "react-router-dom";
import "../error/style/cartempty.css";
import cartempty from "../../assets/images/cartempty.webp";

const CartEmpty = () => {
  const navigate = useNavigate();
  return (
    <div className="cart-empty text-center py-5">
      <div className="empty-icon mb-3">
        <img src={cartempty} alt="cartempty" style={{ margin:"0 auto", width:"230px"}} />
      </div>
      <h2>Unfortunately, Your Cart is Empty</h2>
      <p> Please Add Something in your Cart. </p>
      <button
        className="btn btn-primary primary-button"
        onClick={() => navigate("/")}
       >
          <i className="bi bi-arrow-left"></i> Continue Shopping
      </button>
    </div>
  );
};
export default CartEmpty;